import React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import HearthBeatLoader from '@common/components/loaders/heart-beat/hb-loader';
import { TUnknownObject } from '@common/types/common';

import TimeSlotsSC from './time-slots.styled';
import userInterfaceStore from '@store/user-interface';
import { TRootState } from '@store/root-reducer';
import providerApi from '@utils/api';
import Tag from '@common/components/tag';
import { getTagColors } from '@utils/common';
import TagDescriptions from '@components/tag-descriptions';

const TimeSlots = React.forwardRef<HTMLDivElement, {}>((_, ref) => {
  const dispatch = useDispatch();

  const datetime = useSelector(
    (store: TRootState) => store.userInterface.order.datetime,
  );
  const expert = useSelector(
    (store: TRootState) => store.userInterface.order.expert,
  );
  const medicalInstitution = useSelector(
    (store: TRootState) => store.userInterface.order.medicalInstitution,
  );
  const expertise = useSelector(
    (store: TRootState) => store.userInterface.order.expertise,
  );
  const { time, year, month, day } = datetime;

  const handleTimeSelectClick = (time: string, eventId: string, event: TUnknownObject) => {
    dispatch(userInterfaceStore.selectSlot({ time, eventId, event }));
  };

  const date = `${year}-${month}-${day}`;

  const params =
    `date=${moment(date).format('YYYY-MM-DD')}` +
    `&expertId=${expert.id}&workspaceId=${medicalInstitution.id}`;

  const { isFetching: availableSlotsLoading, data: availableSlots } = useQuery(
    ['availableSlots', date],
    async () => {
      const result = await providerApi.custom(
        `/e-calendar/e-visit/available-slots?${params}`,
        {
          method: 'GET',
        },
      );
      return result.data.slots;
    },
  );

  return (
    <TimeSlotsSC ref={ref}>
      {availableSlotsLoading && (
        <div className="slots-loading">
          <HearthBeatLoader />
        </div>
      )}
      {!availableSlotsLoading &&
        availableSlots &&
        availableSlots.map((slot: TUnknownObject, idx: number) => {
          const tsTime = moment(slot.from).format('HH:mm');
          const { backgroundColor, textColor } = getTagColors(
            slot,
            time === tsTime,
          );

          return (
            <Tag
              key={idx}
              backgroundColor={backgroundColor}
              textColor={textColor}
              name={slot.type === 'premium' ? tsTime + ' *' : tsTime}
              onClick={() => handleTimeSelectClick(tsTime, slot.eventId, slot)}
              className={'time-slot'}
              displayStar={slot.type === 'premium'}
            />
          );
        })}
      {availableSlots ? <TagDescriptions slots={availableSlots} /> : null}
    </TimeSlotsSC>
  );
});

export default TimeSlots;
